import React, { Component } from 'react';
import { Card } from 'antd';

import DescriptionList from '@comm/DescriptionList';
import TableFile from '../comm/TableFile';
import TableIncome from '../comm/TableIncome';

const { Description } = DescriptionList;
class Open extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataItem: this.props.data,
    };
  }

  componentDidMount() {}

  componentWillReceiveProps(nextProps) {
    this.setState({
      dataItem: nextProps.data,
    });
  }

  render() {
    const { dataItem } = this.state;
    return (
      <div className="form-open mb16">
        <Card title="错款退还详情">
          <DescriptionList size="large" col={1}>
            <Description term="付款公司">{dataItem.company}</Description>
            <Description term="客户名称">{dataItem.custom}</Description>
            <Description term="资金流水">
              <TableIncome dataSource={dataItem.incomes || []} disabled />
            </Description>
            <Description term="退款金额">{dataItem.price}</Description>
            <Description term="公司抬头">{dataItem.accountName}</Description>
            <Description term="银行账号">{dataItem.account}</Description>
            <Description term="开户行">{dataItem.accountBank}</Description>
            <Description term="附件">
              <TableFile dataSource={dataItem.files || []} disabled />
            </Description>
            <Description term="退款说明">{dataItem.reason}</Description>
          </DescriptionList>
        </Card>
      </div>
    );
  }
}
export default Open;



// WEBPACK FOOTER //
// ./src/components/incubator/refund/FormOpen.js